<template>
  <div class="h5_hasAgent">
      <div v-if="!userInfo">
          <van-empty class="noLogin" :description="$t('other.a1782')" >
          <van-button  type="info" class="bottom-button" @click="toLogin()">{{$t('other.a1765')}}</van-button>
          </van-empty>
      </div>

      <div  v-else>
         <van-empty v-if="!DataList.length" class="noLogin" :description="$t('other.a1783')" ></van-empty>
         <div v-else>
           <div class="recommend">{{$t('other.a1781')}}</div>
            <div  class="item_wrapper">
                <div class="item_data" @click="viewDetail(item)"  v-for="(item,index) in DataList" :key="index">
                  <div class="pic_box"><img :src="item.image" /></div>
                  <div class="item_desc">{{item.groupName}}</div>
                  <div class="item_text">{{$t('other.a1713')}}：￥{{item.minPrice}}</div>
                  <div class="item_text">{{$t('other.a1740')}}：{{item.amount >= 0 ? item.amount : 0}}</div>
                  <div class="item_button" >
                    <span class="country">{{$t('other.a1774')}}：{{country(item.country)}}</span>
                </div>
              </div>
         </div>
        </div>
      </div>

  </div>
</template>

<script>
import api from '../../api/api'
import newOrderApi from '../../api/moudles/newOrders'
import utils from '../../utils/utils'
import jsonp from '../../api/jsonp'

export default {
data(){
  return{
    userName:'123',
    DataList:[],
    userId:null,
    active:1,
    name:'',
    id:'',
    userInfo:null

    
  }
},
created(){
this.init()
 this.getData()
},
methods:{

  init(){
      this.userInfo=JSON.parse(localStorage.getItem('userInfo'))
      this.id=this.userInfo.userId
      this.name=this.userInfo.userName
      
  },  

  toLogin(){
      this.$router.push({
        path:'/mh5/login',
        query:{
          invitationCode:this.$route.query.invitationCode
        }
      })
  },

  signOut(){
      localStorage.removeItem('userInfo')
      this.$toast(this.$t('other.a1776'))
      this.userInfo=null
  },

  country(id){
    return utils.conutryConversion(id)
  },



  viewDetail(item){
    let userData=JSON.parse(localStorage.getItem('userInfo'))

    if(!userData){
      this.$toast(this.$t('other.a1777'))
      this.$router.push({
        path:'/mh5/login',
        query:{
          invitationCode:this.$route.query.invitationCode
        }
      })
      return
    }
    this.$router.push({
      path:'/mh5/productDetail',
      query:{
        groupId:item.groupId,
        productId:item.productId,
        invitationCode:this.$route.query.invitationCode
      }
      
      })
  },

  getData(){
    let stores=JSON.parse(localStorage.getItem('userInfo')).stores.filter(p => {
        if(p.storeType == 4) {
          return p.storeId
        }
      })
     document.title =this.$t('other.a1779')+ JSON.parse(localStorage.getItem('userInfo')).userId + this.$t('other.a1780')
    newOrderApi
    .getDistributionStoreItems({
      name:null,
      offset:null,
      page:null,
      shopIds:JSON.parse(localStorage.getItem('userInfo')).shopIds,
      storeIds:stores.map(p => {return p.storeId}),
      userId:JSON.parse(localStorage.getItem('userInfo')).userId
    })
    .then(res => {
    if(res.code === 200 ){
    console.log('desc11',res.data)
    this.DataList=res.data.groups
    }else{
    this.$toast(res.msg)
    }
    })
  }

}
}

</script>
<style lang="scss" scoped>

@media (min-width: 1200px)  {
      .h5_mobile{
        background: #409eff;
        height: 100vh;
        font-size: 18px;
      }
}


@media (min-width: 1200px)  {
        .h5_mobile{
        background: #409eff;
        height: 100vh;
        font-size: 18px;



        
      }
}



@media (min-width: 575px) and (max-width: 991px)   {
        .h5_mobile{
        background: #eee;
        height: 100vh;
        font-size: 18px;
        color: red;
      }





}





@media (max-width: 575px)  {
  html{
    font-size: 25px;
  }

  .h5_hasAgent{
      background: #eee;
      min-height: 100vh;
      padding-bottom: 2rem;





      img{
        width: 100%;
      }



      .recommend{
        width:100%;
        text-align: center;
        font-size: 1rem;
        color: #fff;
        font-weight: bold;
        padding: 10px 0;
      }




      .item_wrapper{
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        margin: 0 10px;
        flex-wrap: wrap;
        
        .item_data{
          width:48%;
          background: #fff;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 5px ;
          margin-bottom: 5px ;
          font-size: 0.6rem;
        }

        .item_desc{
          margin: 5px 0;
          box-sizing: border-box;
          padding: 5px 10px;
          height: 3rem;
          overflow: hidden;
          color: rgb(95, 95, 95);
         
        }

        .item_text{
          width: 100%;
          text-align: left;
          padding-left:15px;
          margin-bottom:5px
        }

        .item_button{
          text-align: right;
          width: 100%;
          margin-bottom:10px;
          display: flex;
          justify-content: space-between;


          .country{
            font-size: 10px;
            color: red;
            padding:5px
          }


          .button{
            color: #fff;
            background-color: #ff6034;
            border-radius: 2px;
            box-sizing: border-box;
            padding: 2px 3px;
            margin-right: 2px;
           
          }
          
        }
      }


      .pic_box{
        width: 6rem;
        height: 6rem;
        overflow: hidden;
        box-sizing: border-box;
        padding:0.2rem 0
      }


      .noLogin{
          height: 100vh;
      }


      .center_wrapper{
          margin-top: 20px;
      }


      .desc_info{
          display: flex;
          background: #fff;
          box-sizing: border-box;
          padding:10px 0.7rem;

          .pic_box{
              width: 3rem;
              height: 3rem;
              overflow: hidden;
              margin-right: 0.7rem;


              img{
                  width:100%
              }
          }

          .id_desc{
              font-size: 0.7rem;
              padding:10px 0
          }
      }
  }



}





</style>